import { Cents, LocaleEnum, cents, centsToUnits, units } from '@systemeio/ui'
import { ProductOrderItemInterface } from 'shared/types/payment-interface'
import { currencyFormat } from 'shared/utils/currency-format'

export function getProductPriceAmount(
  quantity: number,
  productOrderItem?: ProductOrderItemInterface,
  locale?: LocaleEnum,
) {
  let price

  if (!productOrderItem) {
    return price
  }

  const calculatePrice = (priceInCents: Cents, quantity: number) => {
    return units(centsToUnits(cents(priceInCents)) * quantity)
  }

  if (productOrderItem.productVariant && productOrderItem.productVariant.price) {
    price = currencyFormat(
      calculatePrice(productOrderItem.productVariant.price, quantity),
      productOrderItem.product.currency,
    )

    return price
  }

  return currencyFormat(
    calculatePrice(productOrderItem.product.price, quantity),
    productOrderItem.product.currency,
    locale,
  )
}
